export const createPaymentMethodsSlice = (set, get) => ({
  paymentMethods: {
    savedPaymentMethods: [],
    showAddPaymentForm: false,
    showSavedPaymentMethods: true,
    selectedPaymentMethod: null,
    loading: false,
    saveStripePaymentMethodLoading: false,
    error: null,
    success: null,
  },
  paymentMethodsActions: {
    setSavedPaymentMethods: (savedPaymentMethods) =>
      set((state) => { state.paymentMethods.savedPaymentMethods = savedPaymentMethods; }),
  
    setShowAddPaymentForm: (showAddPaymentForm) =>
      set((state) => { state.paymentMethods.showAddPaymentForm = showAddPaymentForm; }),
  
    setSelectedPaymentMethod: (selectedPaymentMethod) =>
      set((state) => { state.paymentMethods.selectedPaymentMethod = selectedPaymentMethod; }),
  
    setShowSavedPaymentMethods: (showSavedPaymentMethods) =>
      set((state) => { state.paymentMethods.showSavedPaymentMethods = showSavedPaymentMethods; }),  
  
    setLoading: (loading) =>
      set((state) => { state.paymentMethods.loading = loading; }),
  
    setError: (error) =>
      set((state) => { state.paymentMethods.error = error; }),

    setSuccess: (success) =>
      set((state) => { state.paymentMethods.success = success; }),

    setSaveStripePaymentMethodLoading: (saveStripePaymentMethodLoading) =>
      set((state) => {
        state.paymentMethods.saveStripePaymentMethodLoading =
          saveStripePaymentMethodLoading;
      }),
  }
});
